export const REFERRAL_LINK_PAGE_PARAMS = {
  code: 'code',
}

export const REFERRAL_LINK_PAGE_SEARCH_PARAMS = {
  step: 'step',
}

export interface ClientDetailsFormValues {
  email: string
  telephone: string
  fullName: string
  services: IRI[]
  circumstances?: string
  dateOfBirth?: string
  addressLine1?: string
  city?: string
  postcode?: string
  hasCheckedRestrictedServiceCheckbox?: boolean
}

export const ClientDetailsFormFields: Record<
  keyof ClientDetailsFormValues,
  keyof ClientDetailsFormValues
> = {
  email: 'email',
  telephone: 'telephone',
  fullName: 'fullName',
  services: 'services',
  circumstances: 'circumstances',
  dateOfBirth: 'dateOfBirth',
  addressLine1: 'addressLine1',
  city: 'city',
  postcode: 'postcode',
  hasCheckedRestrictedServiceCheckbox: 'hasCheckedRestrictedServiceCheckbox',
}
